import includes from 'lodash/includes';
import { createSelector } from 'reselect';
import * as actionTypes from './actionTypes';
import * as constants from './constants';
/**
 * Input selectors
 */ const mainSelector = (state)=>state[constants.MODULE_ID];
const fetchingSelector = (state)=>state[constants.MODULE_ID].fetching;
const sendingSelector = (state)=>state[constants.MODULE_ID].sending;
const errorsSelector = (state)=>state[constants.MODULE_ID].errors;
/**
 * Organizations country code overwrite
 */ export const countryCode = createSelector(mainSelector, (state)=>state.countryCode);
/**
 * Select pagination params
 */ export const paginationParams = createSelector(mainSelector, (state)=>state.paginationParams);
/**
 * Paginated organizations count
 */ export const organizationsCount = createSelector(mainSelector, (state)=>state.organizationsCount);
/**
 * Select paginated organizations
 */ export const organizations = createSelector(mainSelector, (state)=>state.organizations);
/**
 * Select account organization memberships
 */ export const organizationMemberships = createSelector(mainSelector, (state)=>state.organizationMemberships);
/**
 * Select details for the chosen organization membership
 */ export const organizationMembershipDetails = createSelector(mainSelector, (state)=>state.organizationMembershipDetails);
/**
 * Select organization template based on country
 */ export const organizationTemplate = createSelector(mainSelector, (state)=>state.organizationTemplate);
//----------------------------------------------------------------------------------------------------------------------
/**
 * Organizations list fetching action
 */ export const isFetchOrganizationInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_ORGANIZATIONS));
//----------------------------------------------------------------------------------------------------------------------
/**
 * Organization template fetching action
 */ export const isFetchOrganizationTemplateInProgress = createSelector(fetchingSelector, (state)=>includes(state, actionTypes.FETCH_ORGANIZATION_TEMPLATE));
export const hasFetchOrganizationTemplateErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.FETCH_ORGANIZATION_TEMPLATE));
//----------------------------------------------------------------------------------------------------------------------
export const isCreateOrganizationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.CREATE_ORGANIZATION));
export const hasCreateOrganizationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.CREATE_ORGANIZATION));
//----------------------------------------------------------------------------------------------------------------------
export const isJoinOrganizationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.JOIN_ORGANIZATION));
export const hasJoinOrganizationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.JOIN_ORGANIZATION));
//----------------------------------------------------------------------------------------------------------------------
export const isLeaveOrganizationInProgress = createSelector(sendingSelector, (state)=>includes(state, actionTypes.LEAVE_ORGANIZATION));
export const hasLeaveOrganizationErrors = createSelector(errorsSelector, (state)=>includes(state, actionTypes.LEAVE_ORGANIZATION));
